import type { FC } from 'react';
import { ProsConsLists } from '@/components/hub/ProsConsLists';
import type {
  BookmakerFeaturesCons,
  BookmakerFeaturesImages,
  BookmakerFeaturesPros,
} from '@/types/bookmaker';
import MarkdownContent from '../MarkdownContent';
import { SectionImagesList } from './SectionImagesList';
import { HubSectionTitle } from './SectionTitle';

interface FeaturesSectionProps {
  title: string;
  text: string;
  pros: BookmakerFeaturesPros;
  cons: BookmakerFeaturesCons;
  images: BookmakerFeaturesImages;
}

export const FeaturesSection: FC<FeaturesSectionProps> = ({
  title,
  text,
  pros,
  cons,
  images,
}) => {
  return (
    <div
      className="flex flex-col gap-3 rounded-lg bg-medium-gray p-4"
      id="features"
    >
      <HubSectionTitle>{title}</HubSectionTitle>
      {images?.data && (
        <SectionImagesList
          imageAltPrefix="bookmaker-logo-features-section"
          images={images.data}
        />
      )}
      <MarkdownContent>{text}</MarkdownContent>
      <ProsConsLists cons={cons} pros={pros} />
    </div>
  );
};
